import { render, staticRenderFns } from "./vehicles.vue?vue&type=template&id=710f09c8"
import script from "./vehicles.vue?vue&type=script&lang=js"
export * from "./vehicles.vue?vue&type=script&lang=js"
import style0 from "./vehicles.vue?vue&type=style&index=0&id=710f09c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports